import React, { Component } from 'react'
import { Grid, Box, IconButton} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import useStyles from './styles/CarouselItemStyle'
import { getDuration }  from '../../../services/Utils'

class CarouselItem extends Component {

  render() {
    const classes = this.props.classes;
    return (
      <Grid
        style={{cursor: this.props.main ? 'pointer': 'auto'}}
        container
        justify='center'
        alignItems='center'
      >
        <Grid item className={`section-carousel-item-card`}>
          <Box style={{height: this.props.style.height}} className={`${classes.gradientBox} section-carousel-item-card`} />
          <img
            alt={this.props.videoDetails.title}
            className={`section-carousel-item-card`}
            style={this.props.style}
            src={this.props.videoDetails.image}
          />
          <Box hidden={!this.props.main} className={`${classes.durationBox} duration-box`}>
            {getDuration(this.props.videoDetails.duration)}
          </Box>
        </Grid>

        <Grid
          item
          hidden={!this.props.main}
          className={`${classes.playButton} play-button`}
          >
          <IconButton
            style={{cursor: this.props.main ? 'pointer': 'auto'}}
            className={classes.playButton}
            >
            <PlayArrowIcon className={`${classes.playButtonArrow} play-arrow`}/>
          </IconButton>
        </Grid>
      </Grid>
    )
  }
}
export default withStyles(useStyles)(CarouselItem)
